import { Box, Button, makeStyles, Typography, Hidden } from "@material-ui/core";
import FormattedMessage from "features/common/TranslatedMessage";
import VECTORSVG from "images/judge/rafiki.svg";
import React from "react";

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    display: "flex",
    textAlign: "start",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      textAlign: "center",
    },
  },
  icon: {
    fontSize: "5rem",
    color: "#707C97",
  },
  redText: {
    color: theme.palette.common.red,
  },
  primaryText: {
    fontSize: "2rem",
    lineHeight: "2rem",
    fontWeight: "600",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.5rem",
      lineHeight: "2.5rem",
    },
  },
  secondaryText: {
    fontSize: "1.3rem",
    lineHeignt: "1.3rem",
  },
  primaryButtons: {},
  container: {
    width: "50%",
    margin: "0 auto",
    [theme.breakpoints.down("sm")]: {
      width: "90%",
    },
  },
  vectorImage: {
    [theme.breakpoints.down("sm")]: {
      width: "70%",
      order: 1,
      marginBottom: "2rem",
    },
  },
  content: {
    [theme.breakpoints.down("sm")]: {
      order: 2,
    },
  },
}));

export default function ClaimantDecision({
  rejectingHandler,
  activeDispute,
  acceptingHandler,
}) {
  const classes = useStyles();

  return (
    <Box>
      <Box height="5rem"></Box>
      <Box className={classes.container}>
        <div className={classes.mainContainer}>
          <div className={classes.content}>
            <Typography className={classes.primaryText}>
              <FormattedMessage id="pages.waitingScreens.claimantDecisionOption.question1" />
              {/* {flowType} */}
            </Typography>
            <Box height="3rem" />
            <Typography className={classes.primaryText}>
              <FormattedMessage id="pages.waitingScreens.claimantDecisionOption.question2" />
            </Typography>
            <Box height="2rem"></Box>
          </div>
          <Hidden smDown>
            <Box flexGrow={1}></Box>
          </Hidden>
          <img
            className={classes.vectorImage}
            src={VECTORSVG}
            alt="judge svg image"
          />
        </div>
        <Box height="2rem"></Box>
        <Box height="1.5rem"></Box>
        <Box display="flex" justifyContent="center">
          <Button variant="outlined" color="primary" onClick={acceptingHandler}>
            <FormattedMessage id="buttons.yes" />
          </Button>
          <Box width="1.5rem"></Box>
          <Button
            variant="contained"
            color="primary"
            onClick={rejectingHandler}
          >
            <FormattedMessage id="buttons.no" />
          </Button>
        </Box>
        <Box height="2rem" />
      </Box>
    </Box>
  );
}
